@if (card.state !== CardState.Hidden) {
    <div
        class="card-placeholder"
        [class.card-placeholder-rotated]="rotated"
        [class.card-placeholder-compact]="compact"
        [class.card-placeholder-back]="card.state === CardState.Back || card.state === CardState.Checked"
    >
        @if (card.state !== CardState.Empty && card.state !== CardState.Back) {
            @if (card.state === CardState.Show) {
                <app-card [card]="card.value" [rotated]="rotated" [compact]="compact"></app-card>
            } @else if (card.state === CardState.Checked) {
                <div class="card-icon-check"></div>
            } @else {
                <app-card-message
                    i18n
                    [back]="card.state === CardState.MessageFaceDown"
                    [textOnly]="rotated || card.state === CardState.MessageFlipCard"
                    [compact]="compact"
                >
                    @switch (card.state) {
                        @case (CardState.MessageFaceDown) {
                            @if (compact) {
                                Face down card
                            } @else {
                                Face down card
                            }
                        }
                        @case (CardState.MessageFaceUp) {
                            @if (compact) {
                                Face up card
                            } @else {
                                Face up card
                            }
                        }
                        @case (CardState.MessageFlipCard) {
                            Flip card on table
                        }
                    }
                </app-card-message>
            }
        }
    </div>
}
